initDarkModeTheme();

function initDarkModeTheme() {
    const isDark =
        localStorage.getItem('darkTheme') === '3' ||
        (localStorage.getItem('darkTheme') === '1' &&
            window.matchMedia &&
            window.matchMedia('(prefers-color-scheme: dark)').matches);
    if (isDark) {
        document.body.style.backgroundColor = '#101116';
        document.body.classList.add('dark-theme');

        const themeCSSID = 'themeCSS';

        if (!document.getElementById(themeCSSID)) {
            var head = document.getElementsByTagName('head')[0];
            var link = document.createElement('link');
            link.id = themeCSSID;
            link.rel = 'stylesheet';
            link.href = 'dark-theme.css';
            head.appendChild(link);
        }
    }
}
